import { createFailure, createSuccess } from "./OperationResult.js";
import { parseError } from "./parseError.js";
export async function tryExecuteSimple(func) {
    try {
        return createSuccess(await func());
    }
    catch (error) {
        return createFailure(parseError(error));
    }
}
